/**
 * Scenarios Service
 * Henter og håndterer træningsscenarier fra backend
 */
import { LIVEKIT_CONFIG } from '../config/livekit.config';

export interface Scenario {
  id: string;
  name: string;
  description: string;
}

/**
 * Default scenarier (fallback hvis backend ikke er tilgængelig)
 */
export const DEFAULT_SCENARIOS: Scenario[] = [
  {
    id: 'mobildata_apn',
    name: 'Mobildata Problem (APN)',
    description: 'Kunde ringer fordi mobildata ikke virker - løsning er APN indstillinger'
  },
  {
    id: 'forsinket_levering',
    name: 'Forsinket Pakkelevering',
    description: 'Kunde ringer fordi pakke ikke er ankommet - løsning er at spore pakke'
  },
  {
    id: 'forkert_faktura',
    name: 'Forkert Fakturering',
    description: 'Kunde ringer fordi fakturaen er for høj - løsning er at finde fejlen'
  },
  {
    id: 'ødelagt_produkt',
    name: 'Ødelagt Produkt ved Levering',
    description: 'Kunde har modtaget ødelagt vare - løsning er ombytning'
  },
  {
    id: 'forsikring_salg',
    name: 'Forsikring Salg',
    description: 'Agent skal sælge forsikring til kunden'
  },
  {
    id: 'nrgi_price_increase_2026',
    name: 'NRGi pristigning 2026',
    description: 'Kunde ringer omkring pristigning hos NRGi'
  },
  {
    id: 'mundtlig_eksamen',
    name: 'Mundtlig Eksamen Simulator',
    description: 'AI-eksaminator der eksaminerer studerende i deres rapport/projekt gennem en naturlig faglig samtale.'
  }
];

/**
 * Hent alle tilgængelige træningsscenarier fra backend
 * Hvis backend fejler, returner default scenarier
 */
export const fetchScenarios = async (): Promise<Scenario[]> => {
  try {
    console.log('📥 Henter scenarier fra backend:', LIVEKIT_CONFIG.scenariosEndpoint);
    
    const response = await fetch(LIVEKIT_CONFIG.scenariosEndpoint);
    
    if (!response.ok) {
      console.warn(`⚠️ Scenarios endpoint returnerede ${response.status}, bruger default scenarier`);
      return DEFAULT_SCENARIOS;
    }
    
    const data = await response.json();
    console.log('✅ Scenarier hentet fra backend:', data.scenarios.length, 'scenarier');
    console.log('📋 Scenarier:', data.scenarios.map((s: Scenario) => s.name).join(', '));
    
    // Hvis backend returnerer tom liste, brug defaults
    if (!data.scenarios || data.scenarios.length === 0) {
      console.warn('⚠️ Backend returnerede ingen scenarier, bruger defaults');
      return DEFAULT_SCENARIOS;
    }
    
    return data.scenarios;
  } catch (error) {
    console.error('❌ Fejl ved hentning af scenarier:', error);
    console.log('📋 Bruger default scenarier som fallback');
    return DEFAULT_SCENARIOS;
  }
};

